import {
  User,
  PliUserSetting,
  PliOnboardingSettingValueKeys,
  UserSetting
} from '../types/schema-generated-types';

export const getSettingByName = (user: User, settingName: string): UserSetting | undefined => {
  return user?.settings?.find(x => x.setting === settingName);
};

export const shouldShowOnboardingWelcomeUser = (user?: User): boolean => {
  if (!user) return false;

  const onboardingSetting = getSettingByName(user, PliUserSetting.onboarding);

  if (!onboardingSetting) return true;
  if (!onboardingSetting?.value?.[PliOnboardingSettingValueKeys.viewedWelcome]) {
    return true;
  }

  return false;
};
